module.exports = __webpack_public_path__ + "img/close__ic.0a722a46.svg";